module.exports = __webpack_public_path__ + "img/backlog.ae4d5414.svg";